<template>
  <div>
    <navbar/>
    <error-panel showInPopup="false" />

    <section class="bg-light pt-3 pb-3 hero">
      <div class="container text-center">
        <h1 class="display-4 font-weight-bold">Academic Program</h1>
        <p class="lead mt-5">
          50% discount for students, professors, and researchers.
        </p>
        <p class="lead">
          Collect, Organize & Share educational bookmarks in one place.
        </p>
        <p class="mt-5">
        <a class="btn btn-outline-primary mr-3" href="/#features" target="_blank">features</a>
        <a class="btn btn-outline-primary" href="/#gallery" target="_blank">gallery</a>
        </p>
      </div>
    </section>

    <!-- Who Is Eligible -->
    <section class="pt-3 pb-3 bg-white">
      <div class="container text-center">
        <h2>Who is eligible?</h2>
        <p class="text-muted mb-5">We support the academic community.</p>
        <div class="row">
          <div class="col-md-3 mb-4">
            <div class="card h-100">
              <div class="card-body">
                <h5 class="card-title">Students</h5>
                <p class="card-text text-muted">
                  Undergraduate and graduate students enrolled in accredited institutions.
                </p>
              </div>
            </div>
          </div>
          <div class="col-md-3 mb-4">
            <div class="card h-100">
              <div class="card-body">
                <h5 class="card-title">PhD Researchers</h5>
                <p class="card-text text-muted">
                  Doctoral candidates and research fellows.
                </p>
              </div>
            </div>
          </div>
          <div class="col-md-3 mb-4">
            <div class="card h-100">
              <div class="card-body">
                <h5 class="card-title">Professors</h5>
                <p class="card-text text-muted">
                  Faculty members teaching at universities and colleges.
                </p>
              </div>
            </div>
          </div>
          <div class="col-md-3 mb-4">
            <div class="card h-100">
              <div class="card-body">
                <h5 class="card-title">Academic Staff</h5>
                <p class="card-text text-muted">
                  Researchers and staff affiliated with academic institutions.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>


    <section class="pt-3 pb-3 bg-light">
      <div class="text-center mb-4">
        <h2>Pricing</h2>
        <p class="text-muted">We offer a lifetime 50% discount for you.</p>
      </div>
      <div class="container text-center">
        <div class="row">

          <div class="col-md-4 mb-4">
          </div>

          <div class="col-md-4 mb-4">
            <div class="card h-100 border-primary">
              <div class="card-body text-center">
                <h5 class="card-title text-primary pb-4">Monthly subscription</h5>

                <p>
                  <span style="font-size: 1.5em" class="text-primary"><b>$0.89</b> / month</span><br/>
                  <span class="text-muted">instead of</span>  <span class="text-danger"><del><b>$1.79</b> / month</del></span> <br/>

                  <small class="text-muted">(VAT or local sales taxes may apply)</small>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- How It Works -->
    <section class="bg-white pt-3 pb-3">
      <div class="container">
        <div class="text-center mb-5">
          <h2>How it works</h2>
          <p class="text-muted">Simple and privacy-first verification.</p>
        </div>

        <div class="row">
          <div class="col-md-4 mb-4">
            <div class="card h-100">
              <div class="card-body">
                <h5 class="card-title">1. Start your free trial</h5>
                <p class="card-text">
                  Sign up for the standard free trial using your preferred email address.
                </p>
                <a class="mt-2 btn btn-cta btn-cta-small "
                   data-toggle="modal"
                   data-target="#registerEmailModal">Sign up!</a>
              </div>
            </div>
          </div>

          <div class="col-md-4 mb-4">
            <div class="card h-100">
              <div class="card-body">
                <h5 class="card-title">2. Email us from your academic address</h5>
                <p class="card-text">
                  Send a message to  <a href="mailto:support@justbookmark.it?subject=Academic%20program%20request">support@justbookmark.it</a> from your official school or university email domain to request the Academic discount.
                </p>
              </div>
            </div>
          </div>

          <div class="col-md-4 mb-4">
            <div class="card h-100">
              <div class="card-body">
                <h5 class="card-title">3. Receive your discount code</h5>
                <p class="card-text">
                  If eligible, we’ll send you a discount code that you can apply during checkout to receive the discount.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Privacy Note -->
    <section class="pt-5 pb-5 mb-4 bg-white">
      <div class="container text-center">
        <h4>Note about Privacy-first verification</h4>
        <p class="text-muted mt-3">
          We only verify eligibility through your institutional email domain.
          We do not require student IDs or enrollment documents.
        </p>
      </div>
    </section>

    <tlfooter/>
</div>
</template>

<script>
import navbar from "@/components/NavBar";
import tlfooter from "@/components/Footer";
import ErrorPanel from "@/components/ErrorPanel";

export default {
  name: "EducationDiscount",
  head: {
    title: 'just bookmark it! - Academic Program'
  },
  components: {
    ErrorPanel, navbar, tlfooter
  }
};
</script>

<style>


</style>
